module.exports = __webpack_public_path__ + "img/title_million.311f036d.png";